const ACTION_SCOPE = '[Applications]';
export class GenerateApplications {
  static readonly type = `${ACTION_SCOPE} Generate Applications`;
  constructor(public payload: { examId: string, numberOfApplications: number }) { }
}
export class GetUserApplications {
  static readonly type = `${ACTION_SCOPE} Get User Applications`;
  constructor(public userId: string) { }
}
export class AddApplication {
  static readonly type = `${ACTION_SCOPE} Add User Application`;
  constructor(public payload: any) { }
}
export class CheckIsUserHasRegistrationsToExamType {
  static readonly type = `${ACTION_SCOPE} Check Status of User Application`;
  constructor(public payload: any) { }
}

export class GetApplicationsByExam{
    static readonly type = `${ACTION_SCOPE} Get Application By Exam Id`;
  constructor(public payload: string) { }
}

// --- /api/applications/users record tables (Examinees / Users / Guests) ---
export class GetExamineeRecords {
  static readonly type = `${ACTION_SCOPE} Get Examinee Records`;
  constructor(public examType?: string) { }
}

export class GetUserRecords {
  static readonly type = `${ACTION_SCOPE} Get User Records`;
  constructor(public examType?: string) { }
}

export class GetGuestRecords {
  static readonly type = `${ACTION_SCOPE} Get Guest Records`;
  constructor(public examType?: string) { }
}

export class ExportUserRecords {
  static readonly type = `${ACTION_SCOPE} Export User Records`;
  constructor(public payload: { status: string; examType?: string; fileName: string }) { }
}
